<template>
    <!--PC暗巷详情页-->
    <ZhaiHeadPC class="zhai-head"></ZhaiHeadPC>

    <div class="container errong">
        <div class="container-fluid p-0 my-2"></div>

        <div class="row gx-2">
            <!-- 左侧部分 -->
            <div class="col-lg-8">
                <div class="LeftPart">
                    <div class="row pp shengse pb-3 pt-1">
                        <div><span class="Title">{{ details.name }}</span></div>

                        <div class="ri mb-1">
                            <small class="bi bi-clock zitipc">
                                <span>&nbsp;{{ details.createTime?.substr(0, 10) }}&nbsp;&nbsp;</span>
                            </small>
                            <small class="bi bi-person-fill zitipc" id="collect">
                                <span>&nbsp;匿名</span>
                            </small>
                        </div>

                        <div class="daxiao">
                            <div class="py-1 jiushi">
                                <span class="jiacu">所属地区：</span>&nbsp;{{ details.province }}-{{ details.city }}
                            </div>

                            <div class="mt-2">
                                <!-- 收藏按钮 -->
                                <button
                                        type="button"
                                        @click="toggleCollect"
                                        class="btn btn-outline-success bi-bag-heart jiushi me-2 button-large"
                                >
                                    {{ isCollected ? '已收藏' : '收藏' }}
                                </button>

                                <!-- 申请删除按钮 -->
                                <button
                                        type="button"
                                        @click="applyDel"
                                        class="btn btn-outline-success bi-trash3 jiushi button-large"
                                        data-bs-toggle="modal"
                                        data-bs-target="#myModal2"
                                >
                                    申请删除
                                </button>
                            </div>
                        </div>
                    </div>


                    <!-- 详细介绍 -->
                    <div class="row shengse mt-2 rounded-top-1">
                        <div class="dixian px-4 py-2 d-flex justify-content-between">
                            <div class="deziti"><i class="shou bi bi-info-circle"></i>详细介绍</div>
                        </div>
                    </div>

                    <!-- ✅ “详细介绍”内容：在这里做登录/VIP拦截 -->
                    <div class="row shengse pb-4 rounded-bottom-1">
                        <div class="px-4 pt-3">
                            <!-- 未登录 -->
                            <template v-if="!isLoggedIn">
                                <div class="py-2 jiushi gate-box">
                                    请先
                                    <router-link to="/login" class="login-register-link">登录</router-link>
                                    或
                                    <router-link to="/register" class="login-register-link">注册</router-link>
                                </div>
                            </template>

                            <!-- 已登录但非VIP/已过期 -->
                            <template v-else-if="!canViewBackAlley">
                                <div class="py-2 jiushi gate-box">
                                    暗巷信息仅限VIP季度会员及以上会员可无限制查看，请&nbsp;
                                    <router-link to="/upgradeVIP" class="upgrade-vip-link">升级VIP</router-link>
                                </div>
                            </template>

                            <!-- VIP有效：显示图片 + 文本 -->
                            <template v-else>
                                <div class="d-flex flex-wrap" ref="gallery">
                                    <div
                                            class="p-2"
                                            v-for="(img, index) in imgList"
                                            :key="index"
                                            style="flex: 0 0 25%; max-width: 25%;"
                                    >
                                        <img class="Img w-100 clickable-img" :src="img" alt="图片预览" />
                                    </div>

                                    <div class="px-3 pb-3 mt-3">
                                        <p class="mb-2 indented" style="font-size: 0.9rem;">
                                            {{ details.history }}
                                        </p>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>

                    <!-- 用户反馈 -->
                    <div class="row shengse mt-2 rounded-bottom-1 rounded-top-1">
                        <div class="dixian px-4 py-2 mb-3 d-flex justify-content-between">
                            <div class="deziti"><i class="shou bi bi-chat-dots-fill"></i>狼友反馈</div>
                        </div>

                        <ZhaiCommentPC
                                v-for="(feedback, index) in feedbackList"
                                :key="index"
                                :data="feedback"
                        ></ZhaiCommentPC>

                        <div class="fk-ad">
                            <button
                                    type="button"
                                    @click="checkLoginBeforeFeedback"
                                    class="btn btn-outline-success mx-auto bi-file-plus-fill button-large"
                            >
                                我要反馈
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 右侧推荐部分 -->
            <div class="col-lg-4">
                <div class="RightPart">
                    <div class="bdcard">
                        <div class="row rr mt-4">
                            <div class="deziti zuo px-4 pb-2 d-flex justify-content-between">
                                <div><i class="shou bi bi-geo-alt-fill"></i>本地其他推荐</div>
                            </div>

                            <div v-for="(item, index) in recommendList" :key="index" class="no-underline mb-1">
                                <ZhaiBACardPC :data="item" @click="updateRoute(item.id)"></ZhaiBACardPC>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="gongxi2"></div>
    <ZhaiFootPC></ZhaiFootPC>

    <!-- 我要反馈 模态框 -->
    <div class="modal fade" id="myModal">
        <div class="modal-dialog modal-dialog-centered feedback-modal">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title motou">我要反馈</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>

                <div class="ant-modal-body mb-2 mt-1">
                    <form class="myform px-3">
                        <div class="form-group mt-3">
                            <label style="font-size:1rem;">反馈信息：</label>
                            <input
                                    style="font-size:1rem;"
                                    type="text"
                                    id="feedback-info"
                                    class="form-control"
                                    v-model="feedbackInfo"
                                    name="feedback-info"
                                    placeholder=""
                                    readonly
                            />
                        </div>

                        <div class="form-group mt-4">
                            <label style="font-size:1rem;">反馈内容：</label>
                            <textarea
                                    class="form-control"
                                    id="content"
                                    v-model="feedbackContent"
                                    placeholder="平台鼓励反馈真实的体验，请勿提交违背事实的虚假反馈，一经发现将关闭你的评论权限，情节严重的将可能直接封号。"
                            ></textarea>
                        </div>

                        <div class="form-group mt-4 px-2">
                            <label style="font-size:1rem;">验证码：</label>
                            <div style="max-width: 300px;">
                                <CaptchaComponent ref="captchaComponent" @validate-captcha="validateCaptcha"></CaptchaComponent>
                            </div>
                        </div>

                        <div class="form-group mt-3">
                            <div class="text-center mb-3">
                                <button
                                        type="button"
                                        @click="submitFeedback"
                                        class="btn btn-success px-5 toushu feedback-submit-btn button-large2"
                                >
                                    提交
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <!-- 申请删除 模态框 -->
    <div class="modal fade" id="myModal2">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title motou">申请删除</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>

                <div class="modal-body">
                    <div class="ant-modal-body motou px-3">
                        <div>
                            本站所有內容来自网友分享，如有内容侵犯到你的隐私、权益或未经你的允许而被他人发布，平台很愿意为你删除，我们同样憎恶出于报复他人的目的而发布的内容。
                            请你提供相关证明材料（比如与帖子内容相符的生活照、或你在其他社交平台发布的链接等，或可以证明联系方式确属于你的证明材料）
                            发邮件至yufenglou123@gmail.com，我们通常会在24小时内处理你的请求，最长不会超过48小时，如果事实逻辑清晰我们将及时为你删除。
                        </div>
                    </div>
                </div>

                <div class="modal-footer di text-center">
                    <button type="button" class="btn btn-success toushu d-block mx-auto button-large2" data-bs-dismiss="modal">
                        关闭
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- 登录警示 模态框 -->
    <div class="modal fade" id="loginWarningModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" style="width: 150px;">
            <div class="modal-content">
                <div class="modal-body text-center d-flex align-items-center justify-content-center">
                    <i class="bi bi-emoji-frown" style="font-size: 2rem; color: #f16b6b;"></i>
                    <p class="mb-0 ms-2" style="font-size: 1rem; color: #f16b6b;">请先登录！</p>
                </div>
            </div>
        </div>
    </div>

    <!-- 成功模态框 -->
    <div class="modal fade" id="successModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" style="max-width: 200px;">
            <div class="modal-content">
                <div class="modal-body d-flex align-items-center justify-content-center">
                    <i class="bi bi-emoji-smile" style="font-size: 2rem; color: #00c26f;"></i>
                    <p class="mb-0 ms-2" style="font-size: 1rem; color: #00c26f;"></p>
                </div>
            </div>
        </div>
    </div>

    <!-- 失败模态框 -->
    <div class="modal fade" id="generalErrorModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-shake" style="max-width: 200px;">
            <div class="modal-content shake">
                <div class="modal-body d-flex align-items-center justify-content-center">
                    <i class="bi bi-emoji-frown" style="font-size: 2rem; color: #dc3545;"></i>
                    <p class="mb-0 ms-2" style="font-size: 1rem; color: #dc3545;"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Viewer from "viewerjs";
    import "viewerjs/dist/viewer.css";
    import { Modal } from "bootstrap";

    import ZhaiHeadPC from "../componentspc/ZhaiHeadPC";
    import ZhaiFootPC from "../componentspc/ZhaiFootPC";
    import ZhaiBACardPC from "../componentspc/ZhaiBACardPC";
    import ZhaiCommentPC from "../componentspc/ZhaiCommentPC";
    import CaptchaComponent from "../componentspc/CaptchaComponent.vue";
    import http from "../utils/http.js";
    import { mapGetters, mapActions } from "vuex";

    export default {
        name: "PDetails2",
        components: {
            ZhaiHeadPC,
            ZhaiFootPC,
            ZhaiBACardPC,
            ZhaiCommentPC,
            CaptchaComponent
        },
        props: ["id"],

        data() {
            return {
                feedbackInfo: "",
                feedbackContent: "",
                details: {
                    id: "",
                    name: "",
                    uploadDate: "",
                    collection: "",
                    province: "",
                    city: "",
                    age: "",
                    price: "",
                    level: "",
                    condition: "",
                    account: "",
                    remark: "",
                    email: "",
                    attention: "",
                    phone: "",
                    source: "",
                    img: "",
                    createTime: "",
                    history: "",
                    presets3: "",
                    presets4: "",
                    presets5: ""
                },
                imgList: [],
                recommendList: [],
                feedbackList: [],
                isCollected: false,
                viewerInstance: null
            };
        },

        computed: {
            ...mapGetters(["isLoggedIn", "getUser"]),

            vipExpired() {
                if (!this.isLoggedIn) return false;
                if (!this.getUser) return false;

                const raw =
                    this.getUser.level_expire_date ??
                    this.getUser.levelExpireDate ??
                    this.getUser.level_expireDate ??
                    this.getUser.level_expireDate ??
                    null;

                if (raw === null || raw === undefined) return true;

                const trimmed = String(raw).trim();
                if (trimmed === "" || trimmed === "null" || trimmed === "undefined") return true;

                if (!Number.isNaN(Number(trimmed))) {
                    const n = Number(trimmed);
                    const ms = String(Math.trunc(n)).length === 10 ? n * 1000 : n;
                    return ms < Date.now();
                }

                let s = trimmed;
                s = s.replace(" ", "T");
                s = s.replace(/([+-]\d{2})(\d{2})$/, "$1:$2");
                if (/^\d{4}-\d{2}-\d{2}$/.test(s)) s += "T23:59:59";

                const d = new Date(s);
                const ms = d.getTime();
                if (Number.isNaN(ms)) {
                    console.warn("VIP expire date parse failed:", raw, "normalized=", s);
                    return true;
                }
                return ms < Date.now();
            },
            isQuarterVipOrAbove() {
                if (!this.isLoggedIn) return false;

                const level = String(this.getUser?.level || "").trim();
                if (!level || level === "null" || level === "undefined") return false;

                return (
                    level.includes("季度会员") ||
                    level.includes("年度会员") ||
                    level.includes("永久会员")
                );
            },
            canViewBackAlley() {
                // 必须：登录 + 季度及以上 + 未过期
                return this.isLoggedIn && this.isQuarterVipOrAbove && !this.vipExpired;
            }
        },

        async created() {
            // ✅ 刷新首屏：先让 vuex 把 user 状态补齐（避免收藏检查太早跑）
            try {
                const maybePromise = this.checkLoginStatus();
                if (maybePromise && typeof maybePromise.then === "function") {
                    await maybePromise;
                }
            } catch (e) {
                console.warn("checkLoginStatus failed:", e);
            }

            // ✅ 首次进入
            this.isCollected = false;
            this.fetchDetails();
            this.fetchFeedbackList();
            this.checkCollectStatus();
        },

        mounted() {
            this.initViewer();
        },

        watch: {
            imgList() {
                this.initViewer();
            },

            // ✅ 切换卡片（右侧推荐点击/手动改 query）要重置并重新检查收藏
            "$route.query.id": {
                immediate: true,
                handler() {
                    this.isCollected = false;
                    this.fetchDetails();
                    this.fetchFeedbackList();
                    this.checkCollectStatus();
                }
            },

            // ✅ 刷新时 user 可能后到：user.id 一回来就补跑一次收藏检查
            "getUser.id": {
                immediate: true,
                handler() {
                    this.checkCollectStatus();
                }
            },

            // 登录/VIP变化也重新处理 viewer
            isLoggedIn() {
                this.initViewer();
                this.checkCollectStatus();
            },
            vipExpired() {
                this.initViewer();
            }
        },

        methods: {
            ...mapActions(["logout", "checkLoginStatus"]),

            updateRoute(id) {
                this.$router.push({ query: { id } });
            },

            showModalInfo(modalId) {
                const modalElement = document.getElementById(modalId);
                if (modalElement) new Modal(modalElement).show();
            },

            applyDel() {
                console.log("申请删除按钮被点击");
            },

            // ✅ 统一拿到可用的 accountId（优先 details.id，兜底 route.query.id）
            getAccountId() {
                const fromDetails = Number(this.details?.id);
                if (fromDetails) return fromDetails;

                const fromRoute = Number(this.$route?.query?.id);
                if (fromRoute) return fromRoute;

                return 0;
            },

            // ✅ 修复核心：accountid/userid 强制 Number，避免后端 Integer 转换/查询失败
            checkCollectStatus() {
                if (!this.isLoggedIn || !this.getUser?.id) return;

                const accountId = this.getAccountId();
                const userId = Number(this.getUser.id);

                if (!accountId || !userId) return;

                const postData = {
                    accountid: accountId,
                    userid: userId,
                    action: "check"
                };

                http
                    .post("/platform/frontEnd/handleCollect2", postData)
                    .then((response) => {
                        if (response?.data?.status === 1) {
                            this.isCollected = !!response.data.data?.isCollected;
                        } else {
                            console.error("检查收藏状态失败:", response?.data?.msg);
                        }
                    })
                    .catch((error) => {
                        console.error("检查收藏状态时出错:", error);
                    });
            },

            toggleCollect() {
                if (!this.isLoggedIn) {
                    const warningModalElement = document.getElementById("loginWarningModal");
                    const warningModal = new Modal(warningModalElement);

                    if (warningModalElement.classList.contains("show")) {
                        warningModalElement.classList.remove("shake-animation");
                        void warningModalElement.offsetWidth;
                        warningModalElement.classList.add("shake-animation");
                    } else {
                        warningModalElement.classList.add("shake-animation");
                        warningModal.show();
                        setTimeout(() => warningModal.hide(), 2000);
                        setTimeout(() => warningModalElement.classList.remove("shake-animation"), 600);
                    }
                    return;
                }

                const accountId = this.getAccountId();
                const userId = Number(this.getUser.id);
                const action = this.isCollected ? "cancel" : "collect";

                if (!userId || !accountId) return;

                const postData = {
                    accountid: accountId,
                    userid: userId,
                    action
                };

                http
                    .post("/platform/frontEnd/handleCollect2", postData)
                    .then((response) => {
                        if (response?.data?.status === 1) {
                            this.isCollected = !this.isCollected;
                            this.showModal(
                                "successModal",
                                this.isCollected ? "收藏成功" : "取消收藏成功",
                                "bi bi-emoji-smile",
                                "#00c26f"
                            );
                        } else {
                            this.showModal(
                                "generalErrorModal",
                                action === "collect" ? "收藏失败" : "取消收藏失败",
                                "bi bi-emoji-frown",
                                "#dc3545"
                            );
                        }
                    })
                    .catch((error) => {
                        console.error(`${action === "collect" ? "收藏" : "取消收藏"}请求错误:`, error);
                        this.showModal("generalErrorModal", "请求发生错误，请稍后再试", "bi bi-emoji-frown", "#dc3545");
                    });
            },

            submitFeedback() {
                const codeInput = document.querySelector(".captcha-input");
                const enteredCaptcha = codeInput ? codeInput.value.trim() : "";
                const actualCaptcha = this.$refs.captchaComponent?.captchaText;

                if (!this.feedbackContent || !this.feedbackContent.trim()) {
                    this.showModal("generalErrorModal", "必填项不可为空！", "bi bi-emoji-frown", "#dc3545");
                    return;
                }

                if (!enteredCaptcha) {
                    this.showModal("generalErrorModal", "必填项不可为空！", "bi bi-emoji-frown", "#dc3545");
                    return;
                }

                if (enteredCaptcha !== actualCaptcha) {
                    this.showModal("generalErrorModal", "验证码错误！", "bi bi-emoji-frown", "#dc3545");
                    this.$refs.captchaComponent?.generateCaptcha?.();
                    return;
                }

                const feedbackData = {
                    message: this.feedbackContent,
                    accountid: this.getAccountId(),
                    userid: Number(this.getUser.id),
                    username: this.getUser.username,
                    userlevel: this.getUser.level || "defaultLevel"
                };

                http
                    .post("/platform/frontEnd/feedback", feedbackData, false, true)
                    .then((response) => {
                        if (response?.data?.status === 1) {
                            this.showModal("successModal", "反馈提交成功", "bi bi-emoji-smile", "#00c26f");
                            const feedbackModal = Modal.getInstance(document.getElementById("myModal"));
                            if (feedbackModal) feedbackModal.hide();
                        } else {
                            this.showModal(
                                "generalErrorModal",
                                `反馈提交失败: ${response?.data?.msg}`,
                                "bi bi-emoji-frown",
                                "#dc3545"
                            );
                        }
                    })
                    .catch((error) => {
                        console.error(`提交反馈时出错: ${error}`);
                        this.showModal(
                            "generalErrorModal",
                            `请求发生错误: ${error.response?.data?.msg || "未知错误"}`,
                            "bi bi-emoji-frown",
                            "#dc3545"
                        );
                    });
            },

            showModal(modalId, message, iconClass, textColor) {
                const modalElement = document.getElementById(modalId);
                if (!modalElement) return;

                const modalBodyP = modalElement.querySelector(".modal-body p");
                const icon = modalElement.querySelector(".bi");

                if (icon) {
                    icon.className = iconClass;
                    icon.style.color = textColor;
                }
                if (modalBodyP) modalBodyP.textContent = message;

                const modal = new Modal(modalElement);
                modalElement.classList.add("shake-animation");
                modal.show();

                setTimeout(() => {
                    modalElement.classList.remove("shake-animation");
                    modal.hide();
                }, 3000);
            },

            checkLoginBeforeFeedback() {
                const warningModalElement = document.getElementById("loginWarningModal");
                const warningModal = new Modal(warningModalElement);

                if (this.isLoggedIn) {
                    new Modal(document.getElementById("myModal")).show();
                } else {
                    if (warningModalElement.classList.contains("show")) {
                        warningModalElement.classList.remove("shake-animation");
                        void warningModalElement.offsetWidth;
                        warningModalElement.classList.add("shake-animation");
                    } else {
                        warningModalElement.classList.add("shake-animation");
                        warningModal.show();
                        setTimeout(() => warningModal.hide(), 2000);
                        setTimeout(() => warningModalElement.classList.remove("shake-animation"), 600);
                    }
                }
            },

            validateCaptcha(isValid) {
                if (!isValid) alert("图形验证码输入不正确！");
            },

            initViewer() {
                this.$nextTick(() => {

                    // 不允许查看：销毁 viewer 并退出
                    if (!this.canViewBackAlley) {
                        if (this.viewerInstance) {
                            this.viewerInstance.destroy();
                            this.viewerInstance = null;
                        }
                        return;
                    }
                    // 允许查看：初始化 viewer
                    const gallery = this.$refs.gallery;
                    if (gallery) {
                        if (this.viewerInstance) {
                            this.viewerInstance.destroy();
                        }

                        this.viewerInstance = new Viewer(gallery, {
                            url(image) {
                                return image.src;
                            }
                        });
                    }
                });
            },

            fetchDetails() {
                const id = this.$route.query.id;
                if (!id) return;

                http
                    .get(`/platform/frontEnd/details2?id=${id}`)
                    .then((response) => {
                        if (response?.data?.status === 1) {
                            this.details = response.data.data || {};
                            this.feedbackInfo = this.details.name || "";

                            this.imgList = [
                                ...(this.details.img ? this.details.img.split(",").map((v) => v.trim()) : []),
                                ...(this.details.presets3 ? this.details.presets3.split(",").map((v) => v.trim()) : []),
                                ...(this.details.presets4 ? this.details.presets4.split(",").map((v) => v.trim()) : []),
                                ...(this.details.presets5 ? this.details.presets5.split(",").map((v) => v.trim()) : [])
                            ];

                            // ✅ 详情回来再补一次 check（兜底，防止首屏时 details.id 为空）
                            this.checkCollectStatus();

                            this.fetchRecommendList(this.details.id);
                        } else {
                            console.error("获取详情数据失败:", response?.data?.msg);
                        }
                    })
                    .catch((error) => {
                        console.error("获取详情数据时出错:", error);
                    });
            },

            fetchRecommendList(id) {
                const accountId = Number(id || this.$route.query.id);
                if (!accountId) return;

                http
                    .get(`/platform/frontEnd/recommendList2?id=${accountId}`)
                    .then((response) => {
                        if (response?.data?.status === 1) {
                            this.recommendList = response.data.data || [];
                        } else {
                            console.error("获取推荐列表失败:", response?.data?.msg);
                        }
                    })
                    .catch((error) => {
                        console.error("获取推荐列表时出错:", error);
                    });
            },

            fetchFeedbackList() {
                const id = this.$route.query.id;
                if (!id) return;

                http
                    .get(`/platform/frontEnd/feedbackList?bizType=2&bizId=${id}`)
                    .then((response) => {
                        if (response?.data?.status === 1) {
                            this.feedbackList = response.data.data || [];
                        } else {
                            console.error("获取用户反馈数据失败:", response?.data?.msg);
                        }
                    })
                    .catch((error) => {
                        console.error("获取用户反馈数据时出错:", error);
                    });
            }
        }
    };
</script>


<style scoped>
    .fb {
        font-weight: bold;
        color: #00c26f;
    }

    .motou {
        font-size: 1rem !important;
    }

    .gongxi2 {
        height: 20px;
    }

    .errong {
        padding-left: 30px;
        padding-right: 30px;
    }

    .container {
        padding-left: 20px;
        padding-right: 20px;
    }

    .LeftPart {
        margin-top: 10px;
    }

    .toushu {
        background-color: #00c26f !important;
        border: none !important;
    }

    .btn {
        font-size: 0.6rem;
        padding: 0.2rem 0.5rem;
        line-height: 1.5;
    }

    .btn-outline-success {
        color: #00c26f;
        border-color: #00c26f;
    }

    .feedback-submit-btn {
        line-height: 2;
        font-size: 0.9rem !important;
    }

    .me-2 {
        margin-right: 0.5rem;
    }

    .pp {
        padding-left: 0.8rem !important;
        padding-right: 0 !important;
        border-radius: 2px;
    }

    .col-lg-4 {
        margin-left: 20px;
    }

    .col-lg-8 {
        width: calc(100% - 20px - 33.333333%);
    }

    .zuo {
        padding-left: 10px !important;
    }

    .shou {
        font-style: normal;
    }

    .jiushi {
        font-size: 0.9rem;
    }

    .indented {
        text-indent: 2em;
    }

    .fk-ad {
        text-align: center;
        padding-bottom: 2rem;
    }

    .ruhe {
        font-size: 0.6rem;
    }

    .bi-telephone-fill {
        font-size: 10px;
    }

    h4 {
        font-size: 0.8rem !important;
    }

    .form-control {
        font-size: 1rem !important;
    }

    .modal-dialog {
        width: 40%;
        max-height: 50%;
        margin: auto;
    }

    .modal-body {
        padding: 0;
    }

    .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1rem;
        border-bottom: 1px solid #dee2e6;
    }

    .modal-content {
        position: relative;
        background-color: white;
        border: 1px solid #dee2e6;
        margin: auto;
        transform: translateY(-45%);
    }

    .feedback-modal {
        width: 40%;
        max-width: 800px;
        margin: auto;
    }

    .login-register-link {
        color: #18b371 !important;
        font-size: inherit;
        text-decoration: none;
        padding: 0;
    }

    .login-register-link:hover {
        text-decoration: underline;
    }

    .upgrade-vip-link {
        color: #00c26f !important;
        font-size: inherit;
        text-decoration: none;
        cursor: pointer;
    }

    .upgrade-vip-link:hover {
        text-decoration: underline;
    }

    /* 拦截提示区域：可选美化 */
    .gate-box {

        padding: 1.2rem 0;
    }

    @keyframes shake {
        0%,
        100% {
            transform: translateX(0);
        }
        10%,
        30%,
        50%,
        70%,
        90% {
            transform: translateX(-2px);
        }
        20%,
        40%,
        60%,
        80% {
            transform: translateX(2px);
        }
    }

    .shake-animation {
        animation: shake 0.5s;
    }

    .button-large {
        padding: 0.3rem 0.7rem;
        font-size: 0.9rem !important;
    }

    .button-large2 {
        padding: 0.3rem 0.7rem;
        font-size: 1rem !important;
    }

    .hover-hand {
        cursor: pointer;
    }

    /* 保持模态框垂直居中 */
    .modal-dialog-centered {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 100vh;
    }
</style>
